<template>
  <qx-card-form title="出险信息" v-show="isShow">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      isShow: false,
      baseForm: {
        accidentTypeOptions: [], // 事故类型
        accidentReasonOptions: [], // 事故原因
        dutyDivideOptions: [], // 责任划分
        accidentDivideOptions: [], // 事故司机
        form: [
          {
            label: '事故时间',
            value: 'accidentDate',
            type: 'date',
            placeholder: '请选择事故时间',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '出险时间',
            value: 'insuranceDate',
            type: 'date',
            placeholder: '请选择出险时间',
            attr: {
              time: '00:00:00',
            },
          },
          {
            label: '事故类型',
            value: 'accidentType',
            type: 'select',
          },
          {
            label: '事故原因',
            value: 'accidentReason',
            type: 'select',
          },
          {
            label: '责任划分',
            value: 'dutyDivide',
            type: 'select',
          },
          {
            label: '事故司机',
            value: 'accidentDivide',
            type: 'select',
          },
          {
            label: '保险公司',
            value: 'insuranceFirm',
            type: 'input',
          },
          {
            label: '理赔金额',
            value: 'insuranceMoney',
            type: 'input',
          },
          {
            label: '报案号',
            value: 'reportNumber',
            type: 'input',
          },
        ],
        rules: {},
      },
    };
  },
  methods: {
    async setList (enumsList) {
      this.baseForm.accidentTypeOptions = enumsList[2];
      this.baseForm.accidentReasonOptions = enumsList[3];
      this.baseForm.dutyDivideOptions = enumsList[4];
      this.baseForm.accidentDivideOptions = enumsList[5];
    },
    receiveData (tar, val) {
      this.$refs.baseForm.reset();
      this.isShow = val.loanSubject === '10';
      if (val.loanSubject === '10') {
        this.baseForm.rules = {
          accidentDate: [ // 事故时间
            { required: true, message: '请选择事故时间', trigger: 'blur' },
          ],
          insuranceDate: [ // 出险时间
            { required: true, message: '请选择出险时间', trigger: 'blur' },
          ],
          accidentType: [ // 事故类型
            { required: true, message: '请选择事故类型', trigger: 'blur' },
          ],
          accidentReason: [ // 事故原因
            { required: true, message: '请选择事故原因', trigger: 'blur' },
          ],
          dutyDivide: [ // 责任划分
            { required: true, message: '请输入责任划分', trigger: 'blur' },
          ],
          accidentDivideName: [ // 事故司机
            { required: true, message: '请输入事故司机', trigger: 'blur' },
          ],
          insuranceFirm: [ // 保险公司
            { required: true, message: '请输入保险公司', trigger: 'blur' },
          ],
          insuranceMoney: [ // 理赔金额
            { required: true, message: '请输入理赔金额', trigger: 'blur' },
          ],
          reportNumber: [ // 报案号
            { required: true, message: '请输入报案号', trigger: 'blur' },
          ],
        };
      } else {
        this.baseForm.rules = {};
      }
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.accidentDate) { // 事故时间
          formData.accidentDate = this.formatDate(formData.accidentDate, 1);
        }
        if (formData.insuranceDate) { // 出险时间
          formData.insuranceDate = this.formatDate(formData.insuranceDate, 1);
        }
      }
      return formData;
    },
    async cacheData () {
      if (this.$refs.baseForm) {
        let res = await this.handleSubData(true);
        return res;
      } else {
        return {};
      }
    },

    async sub () {
      if (this.$refs.baseForm) {
        const formData = await this.handleSubData();
        return formData;
      } else {
        return {};
      }
    },
    init (data = {}) {
      if (data.accidentType) { // 事故类型
        data.accidentType = String(data.accidentType);
      }
      if (data.accidentReason) { // 事故原因
        data.accidentReason = String(data.accidentReason);
      }
      if (data.dutyDivide) { // 责任划分
        data.dutyDivide = String(data.dutyDivide);
      }
      if (data.accidentDivide) { // 事故司机
        data.accidentDivide = String(data.accidentDivide);
      }
      if (data.accidentDate) { // 事故时间
        data.accidentDate = new Date(data.accidentDate);
      }
      if (data.insuranceDate) { // 出险时间
        data.insuranceDate = new Date(data.insuranceDate);
      }
      this.$refs.baseForm.setVal('form', data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
